import { ref } from 'vue'
import { defineStore } from 'pinia'
import { NotifyType } from '../types/notification.enum'
import type { Notify } from '../models/notification.models'

export const useNotificationStore = defineStore('notification', () => {
  const notifications = ref<Notify[]>([])
  const alerts = ref<Notify[]>([])

  const notify = (notification: Notify) => {
    switch (notification.type) {
      case NotifyType.User:
        notifications.value.pop()
        notifications.value.push(notification)
        return
      case NotifyType.System:
        alerts.value.pop()
        alerts.value.push(notification)
        return
    }
  }

  const clear = (type: NotifyType) => {
    switch (type) {
      case NotifyType.User:
        notifications.value = []
        return
      case NotifyType.System:
        alerts.value = []
        return
    }
  }

  return {
    notifications,
    alerts,
    notify,
    clear,
  }
})
